import React from 'react'
import ReactPaginate from 'react-paginate'
import css from './style.css'

const Paginator = (props) => (
  <ReactPaginate
    forceSelected={props.forceSelected}
    marginPagesDisplayed={3}
    pageNum={props.pageNum}
    pageRangeDisplayed={0}
    previousLabel={'< Previous'}
    nextLabel={'Next >'}
    pageClassName={css.page}
    breakClassName={css.page}
    containerClassName={css.container}
    previousClassName={css.previous}
    nextClassName={css.next}
    activeClassName={css.active}
    disabledClassName={css.disabled}
    clickCallback={props.onClick} />
)

export default Paginator



// WEBPACK FOOTER //
// ./src/components/paginator/index.js